import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { contractContent } from '../data/contract-content';
import { extractHeadings } from '../utils/extract-headings';

export function ContractPage() {
  const headings = useMemo(() => extractHeadings(contractContent), []);

  return (
    <LegalPageLayout title="Contrato de Licencia SaaS" lastUpdated="Marzo 2026" headings={headings}>
      <MarkdownRenderer content={contractContent} />
    </LegalPageLayout>
  );
}
